var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.carga < 9999)?_c('v-progress-linear',{attrs:{"value":_vm.porcentajeCarga,"rounded":"","background-opacity":"0.1","color":_vm.colorBarra}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }